export const phoneTypes = ["Office", "Work", "Personal"];
